import { updateData } from 'crustate';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var maxId = function maxId(messages) {
  return messages.reduce(function (a, t) {
    return Math.max(a, t.id);
  }, 0);
};
var ADD_MESSAGE = "messages/add";
var REMOVE_MESSAGE = "messages/remove";
var CLEAR_MESSAGES = "messages/clear";
var addMessage = function addMessage(content, level) {
  return {
    tag: ADD_MESSAGE,
    message: {
      content: content,
      level: level,
      translated: false
    }
  };
};
var addMessageTranslated = function addMessageTranslated(content, level) {
  return {
    tag: ADD_MESSAGE,
    message: {
      content: content,
      level: level,
      translated: true
    }
  };
};
var removeMessage = function removeMessage(id) {
  return {
    tag: REMOVE_MESSAGE,
    id: id
  };
};
var clearMessages = function clearMessages() {
  return {
    tag: CLEAR_MESSAGES
  };
};
var MessagesModel = {
  id: "messages",
  init: function init() {
    return updateData([]);
  },
  update: function update(state, msg) {
    switch (msg.tag) {
      case ADD_MESSAGE:
        return updateData([].concat(state, [_extends({}, msg.message, {
          id: maxId(state) + 1
        })]));
      case REMOVE_MESSAGE:
        return updateData(state.filter(function (x) {
          return x.id !== msg.id;
        }));
      case CLEAR_MESSAGES:
        return updateData([]);
      default:
        break;
    }
  }
};

export { ADD_MESSAGE, CLEAR_MESSAGES, MessagesModel, REMOVE_MESSAGE, addMessage, addMessageTranslated, clearMessages, removeMessage };
//# sourceMappingURL=index.esm.js.map
